module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/70f52138aa61599226db62b1a8fd246b.png";